import {
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountryFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
} from '~/swagger/data-contracts';

const WEBSITE_CONTENT_QUERY_KEY = 'websiteContent';

const createQueryKey = <T>(base: readonly unknown[], key: string, request?: T) => {
  const baseKey = [...base, key] as const;
  return request ? ([...baseKey, request] as const) : baseKey;
};

export const websiteContentQueryKeys = {
  all: () => [WEBSITE_CONTENT_QUERY_KEY] as const,
  filter: {
    all: () => [WEBSITE_CONTENT_QUERY_KEY, 'filter'] as const,
    domain: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetDomainFilterRequest) =>
      createQueryKey(websiteContentQueryKeys.filter.all(), 'domain', request),
    customTag: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCustomTagsFilterRequest) =>
      createQueryKey(websiteContentQueryKeys.filter.all(), 'custom-tag', request),
    country: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountryFilterRequest) =>
      createQueryKey(websiteContentQueryKeys.filter.all(), 'country', request),
    commentUserType: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest) =>
      createQueryKey(websiteContentQueryKeys.filter.all(), 'comment-user-type', request),
    tpProgress: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCommentUserTypeFilterRequest) =>
      createQueryKey(websiteContentQueryKeys.filter.all(), 'test-purchase-progress', request),
  },
  count: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetCountRequest) =>
    createQueryKey(websiteContentQueryKeys.all(), 'count', request),
  list: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest) =>
    createQueryKey(websiteContentQueryKeys.all(), 'list', request),
  details: (request?: MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteDetailRequest) =>
    createQueryKey(websiteContentQueryKeys.all(), 'details', request?.website_id),
};
